<template>
  <div class="page-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>账户管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="card-box" shadow="hover" style="margin-top: 20px">
      <!-- 搜索 新增 -->
      <div class="search-wrapper">
        <el-form
          size="mini"
          :inline="true"
          :model="searchForm"
          ref="searchForRef"
          label-width="90px"
          autocomplete="on"
        >
          <el-form-item label="商户名称">
            <el-input v-model="searchForm.merchant_name" placeholder="商户名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="商户编号">
            <el-input v-model="searchForm.merchant_no" placeholder="商户编号" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.status" clearable placeholder="全部">
              <el-option label="启用" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="success" size="mini" @click="searchSubmit">搜索</el-button>
            <el-button type="primary" size="mini" @click="addData">新增账号</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <el-table
        :data="tableLoadData"
        size="mini"
        border
        row-key="id"
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column :index="indexMethod" type="index" label="序号" width="50" align="center"></el-table-column>
        
        <el-table-column label="商户名称" prop="merchant_name" min-width="160" show-overflow-tooltip />
        <el-table-column label="商户编号" prop="merchant_no" min-width="180" show-overflow-tooltip />
      
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == 1 ? 'success' : 'danger'">
              {{ scope.row.status == 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="add_time" width="160" />
        
        <!-- 操作：编辑 + 打款 + 查看记录 -->
        <el-table-column fixed="right" label="操作" width="280" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" text @click="goEdit(scope.row)">编辑</el-button>
            <!-- <el-button type="warning" size="mini" text @click="goPay(scope.row)">打款</el-button>
            <el-button type="info" size="mini" text @click="viewPayRecord(scope.row)">查看记录</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper" style="margin-top: 20px; text-align: right">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10,20,30,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </el-card>

    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="form" size="mini" label-width="110px">
       
        <el-form-item label="商户名称" prop="merchant_name">
          <el-input v-model="form.merchant_name" placeholder="请输入商户名称"></el-input>
        </el-form-item>
        <el-form-item label="商户编号" prop="merchant_no">
          <el-input v-model="form.merchant_no" placeholder="请输入商户编号"></el-input>
        </el-form-item>
       
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" style="width: 100%">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="reset_dialogForm('form')">取消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('form')">确定</el-button>
      </div>
    </el-dialog>

    <!-- 打款弹框 -->
    <el-dialog title="打款" :visible.sync="payDialogVisible" width="500px">
      <el-form :model="payForm" :rules="payRules" ref="payForm" size="mini" label-width="100px">
        <el-form-item label="当前账号">
          <div style="padding: 8px; background: #f7f8fa; border-radius: 4px">
            {{ payForm.account_name }}
          </div>
        </el-form-item>

        <el-form-item label="打款日期" prop="pay_date">
          <el-date-picker
            v-model="payForm.pay_date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择打款日期"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="打款金额" prop="money">
          <el-input v-model="payForm.money" placeholder="请输入打款金额" type="number"></el-input>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="payForm.remark" type="textarea" rows="3" placeholder="备注"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button size="mini" @click="payDialogVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="submitPay">确认打款</el-button>
      </div>
    </el-dialog>

    <!-- 查看打款记录弹框 -->
    <el-dialog title="打款记录" :visible.sync="recordDialogVisible" width="700px" append-to-body>
      <div style="padding: 10px 0;">
        <span style="font-weight: bold;">账号：{{ currentAccountName }}</span>
      </div>
      <el-table
        :data="recordList"
        size="mini"
        border
        row-key="id"
        style="width: 100%"
      >
        <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
        <el-table-column label="打款日期" prop="pay_date" width="120"></el-table-column>
        <el-table-column label="打款金额" prop="money" width="120" align="right">
          <template slot-scope="scope">
            {{ scope.row.money }} 元
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="创建时间" prop="create_time" width="160"></el-table-column>
      </el-table>

      <!-- 记录分页 -->
      <div style="margin-top: 15px; text-align: right;">
        <el-pagination
          background
          @size-change="handleRecordSizeChange"
          @current-change="handleRecordCurrentChange"
          :current-page="recordPageNum"
          :page-sizes="[10,20,30]"
          :page-size="recordPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="recordTotal"
        />
      </div>

      <div slot="footer">
        <el-button size="mini" @click="recordDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "merchantNoList",
  data() {
    return {
      // 搜索
      searchForm: {
        merchant_name: "",
        merchant_no: "",
        status: "",
        proxy_id:''
      },
      loading:false,
      proxyList:[],
      // 列表
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,

      // 弹窗
      dialogFormVisible: false,
      title: "",
      form: {
        merchant_name: "",
        merchant_no: "",
        status: 1,
        id: "",
        proxy_id:''
      },

      // 打款
      payDialogVisible: false,
      payForm: {
        id: "", // 账号ID
        account_name: "",
        pay_date: "",
        money: "",
        remark: "",
      },

      // 打款记录
      recordDialogVisible: false,
      currentAccountId: "",
      currentAccountName: "",
      recordList: [],
      recordPageNum: 1,
      recordPageSize: 10,
      recordTotal: 0,

      // 验证
      rules: {
        merchant_name: [{ required: true, message: "请输入商户名称", trigger: "blur" }],
        merchant_no: [{ required: true, message: "请输入商户编号", trigger: "blur" }],
      },
      payRules: {
        pay_date: [{ required: true, message: "请选择打款日期", trigger: "change" }],
        money: [{ required: true, message: "请输入打款金额", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getProxyList();
    this.DataList();
  },
  filters: {
    dateFormat(add_time) {
      if (!add_time) return "";
      return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  methods: {
     // 远程实时搜索代理
  async remoteSearch(keyword) {
    // 空关键词清空列表
    if (!keyword) {
      this.proxyList = [];
      return;
    }
    this.loading = true;
    try {
       const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        keyword:keyword
      };
      const res =  await this.$axios.proxyListP(param);
      console.log('99999',res)
      this.proxyList = res.data.data || [];
    } catch (err) {
      this.proxyList = [];
    } finally {
      this.loading = false;
    }
  },
    // 列表
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    DataList() {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        account_name: this.searchForm.account_name,
        bank_no: this.searchForm.bank_no,
        status: this.searchForm.status,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.$axios.posMemberListP(param).then((res) => {
        if (res.code === 200) {
          this.tableLoadData = res.data.data;
          this.total = res.data.total;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.DataList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.DataList();
    },
    searchSubmit() {
      this.pageNum = 1;
      this.DataList();
    },

    // 新增
    addData() {
      this.title = "新增银行账号";
      this.form = {
        account_name: "",
        bank_name: "",
        bank_no: "",
        mobile: "",
        status: 1,
        id: "",
      };
      this.dialogFormVisible = true;
    },

    // 编辑
    goEdit(row) {
      this.title = "编辑银行账号";
      this.form = { ...row };
      this.dialogFormVisible = true;
    },

    // 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        const param = {
          id: this.form.id || "",
          merchant_name: this.form.merchant_name,
          merchant_no: this.form.merchant_no,
        
          status: this.form.status,
          company_id: sessionStorage.getItem("company_id"),
          access_token: sessionStorage.getItem("token"),
        };
        if(this.form.id&&this.form.id>0){
          this.$axios.posMemberEdit(param).then((res) => {
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.dialogFormVisible = false;
            this.DataList();
          } else {
            this.$message.error(res.msg);
          }
        });

        }else{
          this.$axios.posMemberAdd(param).then((res) => {
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.dialogFormVisible = false;
            this.DataList();
          } else {
            this.$message.error(res.msg);
          }
        });
        }
        
      });
    },

    reset_dialogForm(formName) {
      this.dialogFormVisible = false;
      this.$nextTick(() => this.$refs[formName].resetFields());
    },

    // 打款
    goPay(row) {
      this.payForm = {
        id: row.id,
        account_name: `${row.account_name}（${row.bank_no}）`,
        pay_date: moment().format("YYYY-MM-DD"),
        money: "",
        remark: "",
      };
      this.payDialogVisible = true;
    },
    submitPay() {
      this.$refs.payForm.validate((valid) => {
        if (!valid) return;

        const param = {
          account_id: this.payForm.id,
          pay_date: this.payForm.pay_date,
          money: this.payForm.money,
          remark: this.payForm.remark,
          company_id: sessionStorage.getItem("company_id"),
          access_token: sessionStorage.getItem("token"),
        };

        this.$axios.shopAccountPay(param).then((res) => {
          if (res.code === 200) {
            this.$message.success("打款记录添加成功");
            this.payDialogVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },

    // =====================================
    // 查看打款记录
    // =====================================
    viewPayRecord(row) {
      this.currentAccountId = row.id;
      this.currentAccountName = `${row.account_name}（${row.bank_no}）`;
      this.recordPageNum = 1;
      this.getPayRecordList();
      this.recordDialogVisible = true;
    },
    getPayRecordList() {
      const param = {
        account_id: this.currentAccountId,
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token"),
        pageNum: this.recordPageNum,
        pageSize: this.recordPageSize,
      };
      this.$axios.shopAccountPayRecord(param).then((res) => {
        if (res.code === 200) {
          this.recordList = res.data.data;
          this.recordTotal = res.data.total;
        }
      });
    },
    handleRecordSizeChange(val) {
      this.recordPageSize = val;
      this.getPayRecordList();
    },
    handleRecordCurrentChange(val) {
      this.recordPageNum = val;
      this.getPayRecordList();
    },
    // 获取门店列表
    getProxyList() {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token")
      };
      this.$axios.proxyListP(param).then(res => {
        if (res.code === 200) this.proxyList = res.data.data;
      });
    },
    
    
  },
};
</script>

<style scoped>
.page-container {
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;
}
.page-breadcrumb {
  margin-bottom: 15px;
}
.card-box {
  border-radius: 8px;
  padding: 20px;
}
.search-wrapper {
  margin-bottom: 20px;
}
.pagination-wrapper {
  text-align: right;
}



/* 下拉样式（保持不变） */
:deep(.shop-select-dropdown .el-select-dropdown__wrap) {
  max-height: 400px !important;
  overflow-y: auto;
}
:deep(.shop-option-item) {
  height: auto !important;
  padding: 8px 12px !important;
  white-space: normal !important;
  line-height: 1.5 !important;
}
.shop-option {
  line-height: 1.5;
}
.shop-name {
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}
.shop-info {
  font-size: 12px;
  color: #909399;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
</style>